import React from "react";
import { ReactComponent as TvUnitSvg } from "../svg/tv-unit.svg";

export default function TvUnitIcon({ size = 64, color = "#32363F", ...props }) {
  return <TvUnitSvg width={size} height={size} style={{ color }} {...props} />;
}
